module.exports = __webpack_public_path__ + "static/media/template.82c13cee.svg";